export default "__VITE_ASSET__Bhv19NQy__"